import React from 'react'
import { Card, Col, Row, Typography, Divider } from 'antd'
import './style.css'

const { Title, Paragraph } = Typography

const Poster = () => {
	return (
		<div className="poster-container">
			<Title level={1} className="poster-title">
				Agent-Based System Architecture
			</Title>
			<Paragraph className="poster-subtitle">
				An event-driven system for executing and evolving business tasks
				through modular, autonomous agents.
			</Paragraph>

			<Card className="poster-intro">
				<Paragraph>
					This project introduces a recursive automation framework
					where autonomous agents collaborate through events to
					achieve user-defined goals. Rather than following fixed
					workflows, the system continuously evaluates, learns,
					builds, and executes functions — adapting in real time with
					minimal human oversight.
				</Paragraph>
			</Card>

			<Row gutter={[16, 16]}>
				<Col span={12}>
					<Card title="Problem" className="poster-section">
						<Paragraph>
							Centralized automation platforms like Zapier become
							rigid, brittle, and hard to scale. Their static,
							linear workflows lack adaptability, prevent
							learning, and fail in complex or evolving
							environments.
						</Paragraph>
					</Card>
				</Col>
				<Col span={12}>
					<Card title="Objective" className="poster-section">
						<Paragraph>
							Design and prototype a modular, event-driven system
							where autonomous agents:
							<ul>
								<li>Identify functional gaps</li>
								<li>Generate or reuse code</li>
								<li>Validate results</li>
								<li>
									Execute toward the goal iteratively and
									intelligently
								</li>
							</ul>
						</Paragraph>
					</Card>
				</Col>

				<Col span={12}>
					<Card title="Methodology" className="poster-section">
						<ul>
							<li>
								Modular service-oriented architecture
								(Collector, Processor, Reporter, Executor)
							</li>
							<li>Python-based microservices using Docker</li>
							<li>Redis/file-based messaging between services</li>
							<li>Goal input and result feedback loop</li>
							<li>
								Recursive validation and self-improvement cycle
							</li>
						</ul>
					</Card>
				</Col>
				<Col span={12}>
					<Card title="Progress So Far" className="poster-section">
						<ul>
							<li>Literature review complete</li>
							<li>Agent logic and architecture defined</li>
							<li>
								MVP agents implemented: Collector, Processor,
								Reporter
							</li>
							<li>
								Recursive execution and retry logic designed
							</li>
						</ul>
					</Card>
				</Col>

				<Col span={12}>
					<Card title="Expected Outcomes" className="poster-section">
						<ul>
							<li>
								A functioning automation prototype that builds,
								tests, and executes business logic
							</li>
							<li>Demonstration of recursive goal completion</li>
							<li>
								Logs proving fault recovery and autonomous
								learning
							</li>
							<li>Full technical documentation and evaluation</li>
						</ul>
					</Card>
				</Col>
				<Col span={12}>
					<Card title="Visuals" className="poster-section">
						<ul>
							<li>Recursive system architecture diagram</li>
							<li>
								Real message flow screenshot (inter-agent
								communication)
							</li>
							<li>
								Timeline or Gantt chart (optional for project
								pacing)
							</li>
						</ul>
					</Card>
				</Col>
			</Row>

			<Divider />
			<Paragraph className="poster-footer">
				Contact: y1j53@students.keele.ac.uk | July 2025
			</Paragraph>
		</div>
	)
}

export default Poster
